import { FC, useCallback, useMemo } from 'react';
import { StandardDialogHeader } from '../../../Components/CommonComponents';
import { Dialog, DialogContent, Grid, DialogActions, Button } from '@mui/material';
import { useStudyForm } from '../Hooks';
import { AddEditStudyForm } from './AddEditStudyForm';
import { MenuBook } from '@mui/icons-material';
import { StudyDto } from '../../../dtos';

export interface IAddEditStudyModalProps {
    isOpen: boolean;
    close: () => void;
    studyToUpdate?: StudyDto;
    companyId?: string;
    openInNewTabOnCreate?: boolean;
    afterCreate?: (newStudy: StudyDto) => void;
};

export const AddEditStudyModal: FC<IAddEditStudyModalProps> = ({ isOpen, close, studyToUpdate, companyId, openInNewTabOnCreate, afterCreate }) => {
    const formManager = useStudyForm(close, studyToUpdate, companyId, openInNewTabOnCreate, afterCreate);
    const { isFormDirty, reset, save } = formManager;
    const isNew = useMemo(() => !studyToUpdate, [studyToUpdate]);

    const handleCloseClicked = useCallback(() => {
        close();
        reset();
    }, [close, reset]);

    return (
        <Dialog open={isOpen} onClose={close} fullWidth maxWidth='md'>
            <StandardDialogHeader icon={<MenuBook />} text={isNew ? 'New Study' : 'Edit Study'} />
            <DialogContent sx={{ marginTop: 3 }}>
                <Grid container direction='row' spacing={2} alignItems='center'>
                    <AddEditStudyForm formManager={formManager} />
                </Grid>
            </DialogContent>
            <DialogActions sx={{ py: 2 }}>
                <Grid container direction='row' justifyContent='end'>
                    <Grid item>
                        <Button variant='outlined' style={{ boxShadow: 'none', marginRight: '15px' }} onClick={handleCloseClicked}>
                            {isFormDirty ? 'Cancel' : 'Close'}
                        </Button>
                        <Button variant='contained' size='medium' onClick={save} sx={{ color: 'error', backgroundColor: 'primary' }}>
                            Save
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
};